<div *ngIf="ngControl.invalid && (ngControl.touched || submitted)" [ngClass]="{'is-invalid': ngControl.invalid}" class="invalid-feedback">
    <ng-content></ng-content>
</div>
